import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroupDirective } from "@angular/forms";
import { Enums } from "../../_models/generatedEnums";
import { ConferenceGuestRoomTypeViewModel, ConferenceSpeakerViewModel, RoomBillingMode } from "../../_models/generatedModels";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToasterService } from "../../_services/toaster.service";
import { AuthenticationService } from "../../_services/authentication.service";
import { AdminConferenceSettingsService, ConferenceCMSService, OrganizationService } from "../../_services/generatedServices";
import { ActivatedRoute, Router } from "@angular/router";
import { DatePickerComponent } from "@progress/kendo-angular-dateinputs";

@Component({
  selector: 'bxl-public-guest-room',
  templateUrl: 'public-guest-room.component.html',
})
export class PublicGuestRoomComponent implements OnInit {
  initialized = false;
  @ViewChild('myForm') myForm: FormGroupDirective;
  @ViewChild('startDatePicker') startDatePicker: DatePickerComponent
  @ViewChild('endDatePicker') endDatePicker: DatePickerComponent
  submitComplete: Promise<{}> | undefined;
  startDate: Date;
  endDate: Date;
  public RoomBillingMode = RoomBillingMode;
  public RoomBillingModeEnum = Enums.RoomBillingModeEnum;
  model: ConferenceSpeakerViewModel;
  types: ConferenceGuestRoomTypeViewModel[];
  conference: any;

  constructor(private toaster: ToasterService, private router:Router, private route: ActivatedRoute, public auth: AuthenticationService, private org: OrganizationService, private admin: AdminConferenceSettingsService, private cmsService: ConferenceCMSService) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      var conferenceSlug = params.get('conferenceSlug');
      var userId = +params.get('userId');

      this.model = new ConferenceSpeakerViewModel();
      this.org.getConferenceBySlugBasic(conferenceSlug).subscribe((conference) => {
        this.cmsService.getSingleGuestRoomPerson(conferenceSlug, userId).subscribe((user) => {
          this.admin.getGuestRoomTypesForConference(conferenceSlug, false).subscribe((result) => {
            this.types = result.filter(x => x.public);
            this.conference = conference;
            this.model = user;

            this.startDate = new Date(this.conference.startDate);
            this.startDate.setDate(this.startDate.getDate() - 5);

            this.endDate = new Date(this.conference.endDate);
            this.endDate.setDate(this.endDate.getDate() + 5);

            if (this.model.checkinDate) {
              this.model.checkinDate = new Date(this.model.checkinDate);
            }

            if (this.model.checkOutDate) {
              this.model.checkOutDate = new Date(this.model.checkOutDate);
            }

            if (this.model.roomType != null) {
              console.log("room type")
              this.types = result.filter(x => x.id == this.model.roomType.id || x.public);
            }

            this.initialized = true;
          });
        });
      });
    });

  }

  compare(val1: ConferenceGuestRoomTypeViewModel, val2: ConferenceGuestRoomTypeViewModel) {
    return val1 && val2 && val1.id == val2.id;
  }

  onSave() {
    this.myForm.form.markAllControlsDirty();

    if (!this.myForm.valid) {
      this.toaster.error('Please fill out all required fields', 'Error');
      return;
    }

    console.log(this.model.roomType);
    this.model.checkinDate = this.model.checkinDate.toLocaleDateString();
    this.model.checkOutDate = this.model.checkOutDate.toLocaleDateString();
    this.submitComplete = new Promise((resetButton: any, reject) => {

      this.admin.updatePersonsGuestRoom(this.conference.id, this.model.user.id, this.model).subscribe((result) => {
        this.toaster.messageDialog('Room Reservation saved! We will reach out if needed!', 'Success').subscribe(result=>{
          this.router.navigate(['../../'], {relativeTo: this.route});
        });
        resetButton();
      }, resetButton());

    });

  }

  public onCancel() {

  }

  public openStart() {
    console.log("here");
    if (!this.model.checkinDate) {
      this.model.checkinDate = new Date(this.conference.startDate);
    }
  }

  public openEnd() {
    console.log("here");
    if (!this.model.checkOutDate) {
      this.model.checkOutDate = new Date(this.conference.endDate);
    }
  }
}
